import { compareConstants } from '../_constants/compare.constants';

export const addFundIdsToCompareFunds = (fund) => ({
	type: compareConstants.ADD_FUNDIDS_TO_COMPARE_FUNDS,
	payload: fund
});

export const updateFundIdsToCompareFunds = (fund) => ({
	type: compareConstants.UPDATE_FUNDIDS_TO_COMPARE_FUNDS,
	payload: fund
});

export const updateTemporaryCompareFunds = (fund) => ({
	type: compareConstants.UPDATE_TEMPORARY_COMPARE_FUNDS,
	payload: fund
});

export const removedTemporaryCompareFunds = (fund) => ({
	type: compareConstants.REMOVED_TEMPORARY_COMPARE_FUNDS,
	payload: fund
});

export const resetTemporaryCompareFunds = () => ({
	type: compareConstants.RESET_TEMPORARY_COMPARE_FUNDS,
});


export const fetchCompareFundsStart = (fundId) => ({
	type: compareConstants.FETCH_COMPARE_START,
	payload: fundId
});

export const fetchCompareFundsSuccess = (compareFunds) => ({
	type: compareConstants.FETCH_COMPARE_SUCCESS,
	payload: compareFunds
});

export const fetchCompareFundsFailure = (errorMessage) => ({
	type: compareConstants.FETCH_COMPARE_FAILURE,
	payload: errorMessage
});

export const fetchCompareFundsByPeriodStart = (data) => ({
	type: compareConstants.FETCH_COMPARE_FUNDS_BY_PERIOD_START,
	payload: data
});

export const fetchCompareFundsByPeriodSuccess = (compareFunds) => ({
	type: compareConstants.FETCH_COMPARE_FUNDS_BY_PERIOD_SUCCESS,
	payload: compareFunds
});

export const fetchCompareFundsByPeriodFailure = (errorMessage) => ({
	type: compareConstants.FETCH_COMPARE_FUNDS_BY_PERIOD_FAILURE,
	payload: errorMessage
});

export const fetchGraphCompareFundsStart = (data) => ({
	type: compareConstants.FETCH_GRAPH_COMPARE_FUNDS_START,
	payload: data
});

export const fetchGraphCompareFundsSuccess = (compareFunds) => ({
	type: compareConstants.FETCH_GRAPH_COMPARE_FUNDS_SUCCESS,
	payload: compareFunds
});

export const fetchGraphCompareFundsFailure = (errorMessage) => ({
	type: compareConstants.FETCH_GRAPH_COMPARE_FUNDS_FAILURE,
	payload: errorMessage
});

export const fetchNavCompareFundsStart = (data) => ({
	type: compareConstants.FETCH_NAV_COMPARE_FUNDS_START,
	payload: data
});

export const fetchNavCompareFundsSuccess = (data) => ({
	type: compareConstants.FETCH_NAV_COMPARE_FUNDS_SUCCESS,
	payload: data
});

export const fetchNavCompareFundsFailure = (errorMessage) => ({
	type: compareConstants.FETCH_NAV_COMPARE_FUNDS_FAILURE,
	payload: errorMessage
});

export const toggleCompareModal = () => ({
	type: compareConstants.TOGGLED_COMPARE_MODAL
});

export const toggleReturn = () => ({
	type: compareConstants.TOGGLE_RETURN
});

export const toggleDrawdown = () => ({
	type: compareConstants.TOGGLE_DRAWDOWN
});

export const toggleProportion = () => ({
	type: compareConstants.TOGGLE_PROPORTION
});

export const clearCompareFund = () => ({
	type: compareConstants.CLEAR_FUND_COMPARE
});

export const insertSearchIndex = (idx) => ({
	type: compareConstants.INSERT_SEARCH_INDEX,
	payload: idx
});

// export const insertScrollPosition = (position) => ({
// 	type: compareConstants.INSERT_SCROLL_POSITION,
// 	payload: position
// });
